import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Providers from 'providers/components';
import ProviderFormHandlers from 'providers/containers/ProviderFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'providers/selectors';
import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups
import { getCompany, getSubcompany } from 'auth/selectors';

class ProvidersFormContainer extends Component {
  render = () => (
    <ProviderFormHandlers
      render={({
        handleSubmit,
        handleValidation,
        handleValueChange,
        isSubmitted,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        isSaving,
      }) => (
        <Providers.FormView
          company={this.props.company}
          provider={this.props.provider}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isFetching={this.props.isFetching}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={this.props.subcompany}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  provider: getEditing(state),
  company: getCompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(ProvidersFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/containers/ProviderFormContainer.js